import React from "react";

type CustomIconProps = {
  size?: number | string;
  style?: React.CSSProperties;
};

const GlobalSearchIcon = ({ size = "1em", style }: CustomIconProps) => {
  return (
    <svg
      viewBox="0 0 270 273.974"
      style={{ fontSize: size, height: size, width: size, ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.602">
        <path
          d="M13.435,0A103.3,103.3,0,0,0,0,8.3,86.632,86.632,0,0,0,20.284,23.684,88.723,88.723,0,0,1,18.633,6.05c.009-.667.045-1.324.066-1.988A13.092,13.092,0,0,1,13.435,0"
          transform="translate(36.939 137.693)"
          fill="#fff"
        ></path>
        <path
          d="M31.925,0,11.783.011A13.031,13.031,0,0,1,0,10.149,85.427,85.427,0,0,0,18.491,49.007a111.543,111.543,0,0,1,15.23-9.452,12.444,12.444,0,0,1,3.442-11.018A113.793,113.793,0,0,1,31.925,0"
          transform="translate(14.044 92.124)"
          fill="#fff"
        ></path>
        <path
          d="M4.453,25.071a12.9,12.9,0,0,1,3.161-.535A87.491,87.491,0,0,1,20.5,0L0,.011a107.593,107.593,0,0,0,4.453,25.06"
          transform="translate(52.51 92.113)"
          fill="#fff"
        ></path>
        <path
          d="M3.14,0A51.5,51.5,0,0,0,0,17.193,52.088,52.088,0,0,0,3.14,35.274V0"
          transform="translate(92.311 126.824)"
          fill="#fff"
        ></path>
        <path
          d="M0,28.1A106.445,106.445,0,0,0,20.652,40.919,112.565,112.565,0,0,1,50.235,0,86.2,86.2,0,0,0,0,28.1"
          transform="translate(33.942 0.707)"
          fill="#fff"
        ></path>
        <path
          d="M0,35.257l26.1-.014a88.66,88.66,0,0,1,17.049-14.52V7.893A112.933,112.933,0,0,1,5.934,0,107.829,107.829,0,0,0,0,35.257"
          transform="translate(52.303 50.331)"
          fill="#fff"
        ></path>
        <path
          d="M.1,42.34a13.03,13.03,0,0,1,12.483,9.391l20.207-.013a114.12,114.12,0,0,1,6.453-37.861A112.938,112.938,0,0,1,16.834,0,85.264,85.264,0,0,0,0,42.351l.1-.011"
          transform="translate(12.976 33.87)"
          fill="#fff"
        ></path>
        <path
          d="M0,37.711a86.261,86.261,0,0,0,49.556-26.2A104.533,104.533,0,0,0,28.363,0,111,111,0,0,1,0,37.711"
          transform="translate(112.058 133.355)"
          fill="#fff"
        ></path>
        <path
          d="M0,34.477a111.257,111.257,0,0,1,23,12.59,85.66,85.66,0,0,0,15.975-31.2A51.772,51.772,0,0,0,7.489,0,113.156,113.156,0,0,1,0,34.477"
          transform="translate(142.93 92.854)"
          fill="#fff"
        ></path>
        <path
          d="M30.977,31.195A85.646,85.646,0,0,0,16.763,0a113.735,113.735,0,0,1-14.7,9.439,12.94,12.94,0,0,1,.847,4.519A12.93,12.93,0,0,1,0,22.088a86.908,86.908,0,0,1,30.977,9.106"
          transform="translate(151.864 35.189)"
          fill="#fff"
        ></path>
        <path
          d="M34.863,51.686V0A106.3,106.3,0,0,0,0,44.222a106.282,106.282,0,0,0,34.863,7.464"
          transform="translate(60.588)"
          fill="#fff"
        ></path>
        <path
          d="M0,0V51.019A106.354,106.354,0,0,0,26.757,47.1a12.942,12.942,0,0,1,4.778-8.825A106.579,106.579,0,0,0,0,0"
          transform="translate(101.991 0.743)"
          fill="#fff"
        ></path>
        <path
          d="M27.4,35.791a13.153,13.153,0,0,1,2.249-.227,12.952,12.952,0,0,1,8.461,3.179,107.123,107.123,0,0,0,14.443-9.2A85.894,85.894,0,0,0,0,0,112.69,112.69,0,0,1,27.4,35.791"
          transform="translate(112.05 0.508)"
          fill="#fff"
        ></path>
        <path
          d="M0,12.788A86.754,86.754,0,0,1,29.79,3.216,13.015,13.015,0,0,1,27.728,0,112.779,112.779,0,0,1,0,3.931v8.856"
          transform="translate(101.991 54.375)"
          fill="#fff"
        ></path>
        <path
          d="M0,45.229A106.651,106.651,0,0,0,32.257,5.487,108.214,108.214,0,0,0,0,0V45.229"
          transform="translate(101.991 125.609)"
          fill="#fff"
        ></path>
        <path
          d="M0,21.878v4.731a114.6,114.6,0,0,1,34.813,5.976A107.186,107.186,0,0,0,41.928,0,51.92,51.92,0,0,0,0,21.878"
          transform="translate(101.991 92.481)"
          fill="#fff"
        ></path>
        <path
          d="M13.081,0a13.153,13.153,0,0,0-2.249.227,13.1,13.1,0,0,0-10.7,11.54A12.3,12.3,0,0,0,0,13.075a12.739,12.739,0,0,0,3.167,8.444,87.52,87.52,0,0,1,11.341-.763l.663,0c2.725.02,5.422.182,8.079.447A12.962,12.962,0,0,0,21.542,3.179,12.952,12.952,0,0,0,13.081,0"
          transform="translate(128.614 36.072)"
          fill="#363636"
        ></path>
        <path
          d="M13.078,0l-.1.011a13.075,13.075,0,0,0,.1,26.15l.966-.1A13.031,13.031,0,0,0,25.827,15.926a13.433,13.433,0,0,0,.331-2.845,13.042,13.042,0,0,0-.6-3.689A13.03,13.03,0,0,0,13.078,0"
          transform="translate(0 76.21)"
          fill="#363636"
        ></path>
        <path
          d="M0,13.031a12.961,12.961,0,0,0,.2,2,12.948,12.948,0,0,0,2.609,6.014A13.092,13.092,0,0,0,8.07,25.106,86.713,86.713,0,0,1,12.557,0,13.327,13.327,0,0,0,3.64,4.012,12.984,12.984,0,0,0,0,13.031"
          transform="translate(47.567 116.649)"
          fill="#363636"
        ></path>
        <path
          d="M170.994,198.715l-41.847-41.831a84.315,84.315,0,0,1-44.4,12.584l-.64,0A84.733,84.733,0,0,1,84.724,0l.64,0A84.6,84.6,0,0,1,154.7,132.419l41.148,41.144-25.2,24.811.341.34ZM85.843,29.981a54.764,54.764,0,0,0-.4,109.526l.427,0a54.764,54.764,0,0,0,.391-109.526Z"
          transform="translate(58.399 59.656)"
          fill="#3cabc9"
        ></path>
        <path
          d="M0,26.868l6.008,6.09a9.572,9.572,0,0,0,7.019,2.716c4.575,0,9.8-2.464,13.993-6.6,7.062-6.962,8.9-16.164,4.189-20.947L23.19,0l-.022.017.1.092L23.278.1l3.874,3.931L1.971,28.841,0,26.868"
          transform="translate(236.183 238.299)"
          fill="#3cabc9"
        ></path>
        <path
          d="M1.9,1.9,0,0V0L1.9,1.9"
          transform="translate(234.155 263.138)"
          fill="#82bfab"
        ></path>
        <path
          d="M30.3,5.1,28.006,2.81,25.2,0,0,24.811l2.5,2.5L5.1,29.919l1.9,1.9.124.129L9.1,33.921,34.282,9.113,30.408,5.181l-.015.008L30.3,5.1"
          transform="translate(229.053 233.219)"
          fill="#f3f3f3"
        ></path>
      </g>
    </svg>
  );
};

export default GlobalSearchIcon;
